import _ from 'lodash';
import { DropdownModel } from '../geral/DropdownModel';

export class ComunicacaoInstrumentoModel {
  constructor({
    id,
    instrumento,
    participante,
    tipoComunicacao,
    baudRate,
    dataBits,
    parity,
    stopBits
  }) {
    this.id = id;
    this.procedimentos = null;
    this.instrumentoId = instrumento?.id;
    if (instrumento) {
      this.instrumentoId = new DropdownModel(instrumento);
    }
    if(participante) this.participanteId = participante.id;
    this.tipoComunicacao = tipoComunicacao;
    this.baudRate = baudRate,
    this.dataBits = dataBits,
    this.parity = parity,
    this.stopBits = stopBits
  }
    get request() {
      let retorno = _.cloneDeep(this);
      retorno.instrumentoId = retorno.instrumentoId?.value;

      return retorno;
  }
}
